exports = module.exports = require("./../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ui-select-option{align-items:center;cursor:pointer;display:flex;font-family:Source Sans Pro,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:.9375rem;user-select:none}.ui-select-option.is-selected{background-color:rgba(0,0,0,.05);color:#23b6b4;font-weight:500}.ui-select-option.is-selected .ui-select-option__checkbox{color:#23b6b4}.ui-select-option.is-highlighted{background-color:rgba(0,0,0,.1)}.ui-select-option__basic,.ui-select-option__image-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ui-select-option__image{display:flex;align-items:center}.ui-select-option__image-object{background-position:50%;background-size:cover;border-radius:50%;height:2rem;margin-right:.75rem;width:2rem}.ui-select-option__checkbox{color:rgba(0,0,0,.38);margin-left:auto}.ui-select-option--type-basic{padding:.375rem .75rem}.ui-select-option--type-image{padding:.25rem .75rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-105794be!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/keen-ui/src/UiSelectOption.vue
// module id = 466
// module chunks = 22